import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { muiTheme } from "@/theme/muiTheme";
import { router } from "./router";
import { ErrorBoundary } from "./ErrorBoundary";
import { AuthBootstrap } from "./AuthBootstrap";
import { SessionExpiredModal } from "@/modules/auth";
import { queryClient } from "./queryClient";
import { WebSocketProvider } from "@/modules/realtime";
import { ForceLogoutListener } from "@/modules/auth/components/ForceLogoutListener";

export function Providers() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          <AuthBootstrap />
          <WebSocketProvider>
            <ForceLogoutListener />
            <RouterProvider router={router} />
          </WebSocketProvider>
          <SessionExpiredModal />
          <Toaster position="bottom-right" richColors closeButton />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
